var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$configInfo.backgroundMusicSwitch)?_c('ActBaseMusic',{attrs:{"audioSrc":_vm.$configInfo.backgroundMusicUrl}}):_vm._e(),_c('router-view'),_c('ActBaseComplaint'),(_vm.$isSnapshotUser == 1)?_c('ActBaseAuthGuide'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }